import { styled } from '@mui/material';
import { CoreDialogActions } from '@youscience/core';

export const sxStyles = {
  dialogWrap: {
    '.MuiPaper-root': {
      maxWidth: '600px',
      width: '100%',
      borderRadius: '12px',
    },
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '2.5rem 1.5rem',
  },
};

export const StyledText = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '400px',
  textAlign: 'center',

  '& > h3:first-of-type': {
    marginBottom: '1.5rem',
  },
}));

export const StyledFooter = styled(CoreDialogActions)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: '1.5rem',
  borderTop: `1px solid ${theme.palette.grey['300']}`,
}));
